import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface PhotoCarouselProps {
  photos: string[];
  alt: string;
}
export function PhotoCarousel({
  photos,
  alt
}: PhotoCarouselProps) {
  const [index, setIndex] = useState(0);
  const multi = photos.length > 1;
  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!multi) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const right = e.clientX - rect.left > rect.width / 2;
    setIndex(i => right ? Math.min(photos.length - 1, i + 1) : Math.max(0, i - 1));
  };
  return <div className="absolute inset-0" onClick={onClick} data-id="element-746" data-mp="3anuc4sjf8wwm">
      <AnimatePresence initial={false} data-id="element-747" data-mp="3apf9sr118vyp">
        <motion.img key={photos[index]} src={photos[index]} alt={alt} draggable={false} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.18,
        ease: 'easeOut'
      }} className="absolute inset-0 h-full w-full select-none object-cover" data-id="element-748" data-mp="3flvx5j0er6aq" />
      </AnimatePresence>
      {multi && <div className="absolute inset-x-4 top-2.5 z-10 flex gap-1.5" aria-hidden="true" data-id="element-749" data-mp="195u0l8owflga">
          {photos.map((p, i) => <span key={p + i} className={`h-1 flex-1 rounded-full transition-colors duration-150 ${i === index ? 'bg-white' : 'bg-white/40'}`} data-id="element-750" data-mp="1nuyfoh0ed9k6" data-mpi={i} />)}
        </div>}
    </div>;
}